import { Button, Typography } from "@grantyd/ui";
import { useFeatures } from "./useFeatures";
import styles from "./Features.module.css";
import { featuresContent as content } from "@/data/discoveryProductData";
import { ReactComponent as BulletPrimary } from "@/assets/icons/bullet-primary.svg";
import { ReactComponent as BulletSecondary } from "@/assets/icons/bullet-secondary.svg";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { defaultData } from "@/data/defaults";

interface content {
  content: typeof content;
}

function Features({ content }: content) {
  const { activeIndex, handlePaginationClick } = useFeatures();
  const isDesktop = useMediaQuery("(min-width: 768px)");

  return (
    <section className={styles.featuresContainer} id="about">
      <div className={styles.featuresHeader}>
        <Typography
          as="h2"
          variant={isDesktop ? "display-md" : "headline-lg"}
          color="primary"
          style={{ fontWeight: "var(--font-weight-bold) !important" }}
        >
          {content.title}{" "}
          <span className={styles.titleHighlight}>
            {content.titleHighlight}
          </span>
        </Typography>
        <Typography
          variant="body-lg"
          color="primary"
          className={styles.featuresDescription}
        >
          {content.description}
        </Typography>
      </div>

      <div id="carousel" className={styles.carousel} data-testid="carousel">
        {content.features.map((feature, index) => (
          <div
            key={index}
            className={`${styles.card} ${feature.dark ? styles.cardDark : ""}`}
          >
            <div>
              <Typography
                as="h3"
                variant="headline-lg"
                className={styles.cardTitle}
              >
                {feature.title}
              </Typography>
              <Typography variant="label-lg" className={styles.cardSubtitle}>
                {feature.subtitle}
              </Typography>
              <Typography variant="body-md">{feature.description}</Typography>
            </div>
            <div className={styles.bullets}>
              {feature.bullets.map((bullet, idx) => (
                <div key={idx} className={styles.bulletItem}>
                  {feature.dark ? (
                    <BulletSecondary className={styles.bulletIcon} />
                  ) : (
                    <BulletPrimary className={styles.bulletIcon} />
                  )}
                  <Typography variant="label-md">{bullet}</Typography>
                </div>
              ))}
            </div>
            <Button
              variant={feature.dark ? "secondary" : "primary"}
              style={{ width: "100%" }}
              size="large"
              onClick={() => {
                window.location.href =
                  content.ctaUrl || defaultData.learnMorePath;
              }}
            >
              Learn More
            </Button>
          </div>
        ))}
      </div>

      <div className={styles.pagination}>
        {content.features.map((_, index) => (
          <div
            key={index}
            className={`${styles.dot} ${
              index === activeIndex ? styles.dotActive : ""
            }`}
            data-testid={`presentation`}
            onClick={() => handlePaginationClick(index)}
          />
        ))}
      </div>
    </section>
  );
}

export default Features;
